import { joiResolver } from "@hookform/resolvers/joi";
import { useForm, useWatch } from "react-hook-form";
import { useEffect } from "react";
import schema from "../schema";
import { IOptionItem } from "../../../../typings/common";

export interface BusinessFormValuesI {
  id?: number,
  codeType: string,
  area?: IOptionItem,
  pool?: IOptionItem,
  company?: IOptionItem,
  companyRelation?: IOptionItem,
  segment?: IOptionItem,
  hasRelation: boolean,
  isActive: boolean,
}

export const initialValues = {
  hasRelation: false,
  isActive: true,
};

const useBusinessForm = () => {
  const methods = useForm<BusinessFormValuesI>({
    defaultValues: initialValues,
    resolver: joiResolver(schema),
  });

  const {
    getValues, resetField, setValue,
  } = methods;

  const removeFieldValue = (name: any) => {
    resetField(name);
    setValue(name, undefined);
  };

  const handleCompanyChange = () => {
    removeFieldValue("companyRelation");
    removeFieldValue("segment");
  };
  const handlePoolChange = () => {
    removeFieldValue("company");
    handleCompanyChange();
  };
  const handleAreaChange = () => {
    removeFieldValue("pool");
    if (getValues("codeType") === "O") {
      setValue("pool", { label: "HO", value: "HO" }, { shouldValidate: true });
    }
    handlePoolChange();
  };
  const handleCodeTypeChange = () => {
    removeFieldValue("area");
    if (getValues("codeType") === "O") {
      setValue("area", { label: "Jakarta", value: "JKT" }, { shouldValidate: true });
    }
    handleAreaChange();
  };

  return {
    methods,
    handleCodeTypeChange,
    handleAreaChange,
    handlePoolChange,
    handleCompanyChange,
  };
};

export default useBusinessForm;
